import React from 'react';
import { bool, func, string } from 'prop-types';
import styled from 'styled-components';
import theme from '@airasia-common/libraries/theming/theme';
import CheckIcon from '@material-ui/icons/Check';
import Wrapper from '../Wrapper';
import { SubBodyText } from '../Text/Heading';
import { PROMOTION_FILTER } from '../../utils/constants';
import Styled from '../../utils/Styled';

const OptionWrapper = styled(Wrapper)`
  display: flex;
  align-items: center;
  flex-direction: row;
  cursor: pointer;
  width: fit-content;
`;

const CheckBox = styled.span`
  width: 20px;
  height: 20px;
  min-width: 20px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.greyLight};
  background: ${({ checked, theme, move }) =>
    checked
      ? move
        ? theme.colors.secondaryMove
        : theme.colors.secondary
      : theme.colors.primaryWhite};
  &:focus {
    border: 1px solid
      ${({ theme, move }) =>
        move ? theme.colors.secondaryMove : theme.colors.secondary};
  }
`;

const PromotionText = Styled(SubBodyText, {
  lineHeight: '22px',
  fontSize: '14px',
  color: theme.colors.greyDarker,
});

const CheckedMark = () => (
  <CheckIcon
    style={{
      width: 14,
      height: 14,
      padding: 3,
      color: theme.colors.primaryWhite,
    }}
  />
);

const CheckboxOption = ({ isSelected, id, text, onChange, isMoveEnabled }) => {
  const handelKeyDown = id => event => {
    if (event.key === 'Enter') {
      event.preventDefault();
      onChange(id, isSelected);
    }
  };
  return (
    <OptionWrapper
      className="check-box"
      onMouseDown={() => onChange(id, isSelected)}
      onKeyDown={handelKeyDown(id)}
    >
      <CheckBox tabIndex={0} checked={isSelected} move={isMoveEnabled}>
        {isSelected && <CheckedMark />}
      </CheckBox>
      <Wrapper pl={12}>
        {id === PROMOTION_FILTER ? (
          <PromotionText>{text}</PromotionText>
        ) : (
          <SubBodyText lineHeight="22px" color={theme.colors.greyDarker}>
            {text}
          </SubBodyText>
        )}
      </Wrapper>
    </OptionWrapper>
  );
};

CheckboxOption.propTypes = {
  isSelected: bool,
  onChange: func,
  id: string,
  text: string,
  isVertical: bool,
  isMoveEnabled: bool,
};

CheckboxOption.defaultProps = {
  isSelected: false,
  onChange: () => {},
  id: '',
  text: '',
  isVertical: false,
  isMoveEnabled: false,
};

export default CheckboxOption;
